import React from "react";
import {navigate, RouteComponentProps} from '@reach/router';
import {withTranslation} from "react-i18next";
import {t} from "i18next";
import styled from "styled-components";
import logo from "../../../assets/logooero32x32.png";
import {Button} from "@material-ui/core";

const ServiceBlock = styled.div`
  max-width: 356px;
  width: 100%;
  background-color: #F1F1F1;
  padding: 44px 29px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ServiceTitle = styled.div`
	color: #3A3A3A;
	text-align: center;
	font-size: 32px;
	font-style: normal;
	font-weight: 500;
	line-height: 135.5%;
	margin-bottom: 40px;
`;

const Flex = styled.div`
	display: flex;
	align-items: center;
	margin-top: 48px;
	gap: 40px;

	@media (max-width: 767px) {
		flex-direction: column;
	}
`;


export interface ChooseApplicationProps extends RouteComponentProps {
}

const ChooseApplication: React.FC<ChooseApplicationProps> = () => {

	const handleRedirect = () => {
		window.location.href = 'https://cryptobanking.oero.io/login';
	};

	return (
		<>
			<span
				className=''
				style={{
					color: '#3A3A3A',
					fontSize: '40px',
					fontWeight: 500,
					width: '100%',
					textAlign: 'center',
					display: 'block',
				}}
			>
				Please select service
			</span>

			<Flex className='flex-center'>
				<ServiceBlock>
					<img src={logo} alt="" style={{width: '40px', marginBottom: '19px'}}/>
					<ServiceTitle>
						Stablecoin
					</ServiceTitle>
					<Button
						style={{ width: "100%", height: "47px" }}
						variant="contained"
						color="primary"
						size={"small"}
						onClick={() => navigate("/login").then()}
					>
						Login Stablecoin
					</Button>
				</ServiceBlock>

				<ServiceBlock>
					<img src={logo} alt="" style={{width: '40px', marginBottom: '19px'}}/>
					<ServiceTitle>
						Crypto Banking
					</ServiceTitle>
					<Button
						style={{width: "100%", height: "47px"}}
						variant="contained"
						color="primary"
						size={"small"}
						onClick={handleRedirect}
					>
						Login Crypto Banking
					</Button>
				</ServiceBlock>
			</Flex>
		</>

	)
};

export default withTranslation()(ChooseApplication)
